import { NavLink, Link } from 'react-router';

import '../assets/styles/privacy-policy.scss';
import { routes } from '../const/routes';

const TermsOfUse = () => (
  <main className="privacy-policy-page">
    <ul className="breadcrumbs">
      <li>
        <NavLink to={routes.landingPage}>Home</NavLink>
      </li>
      <li>
        <NavLink
          to={routes.termsOfUse}
          className={({ isActive }) => (isActive ? 'active' : '')}
        >
          Terms of Use
        </NavLink>
      </li>
    </ul>
    <div className="content terms-of-use-page">
      <h1>TERMS OF USE</h1>
      <div>
        <p>
          laestimator.ai <br />
          Last updated: August 20, 2026
        </p>
      </div>
      <ul>
        {/* 1 */}
        <li>
          <section>
            <h2>General Provisions</h2>
            <div>
              <p>
                <strong className="bold">1.1.</strong> These Terms of Use
                (hereinafter – the “Terms”) govern access to and use of the
                AI-powered project estimation service available at
                laestimator.ai (hereinafter – the “Service” or “Website”),
                operated by LaEurope Sp. z o.o. (ul. Piotrkowska, 148/150,
                miejsc. ŁÓDŹ, kod 90-063, POLSKA, NIP: 8971848582, REGON:
                368844046), trading as Lasoft (hereinafter – “Lasoft”, “We”,
                “Us”, or “Our”).
              </p>
              <p>
                <strong className="bold">1.2.</strong> By accessing, browsing,
                or otherwise using the Service, by completing the estimation
                flow, or by submitting a request through any form on the
                Website, you (hereinafter – the “User” or “you”) confirm that
                you have read, understood, and agree to be bound by these Terms.
                If you do not agree with any part of these Terms, you must not
                use the Service.
              </p>
              <p>
                <strong className="bold">1.3.</strong> These Terms constitute a
                legally binding agreement between you and Lasoft. They apply
                together with Our Privacy Policy, which is incorporated into
                these Terms by reference and describes how We collect and
                process personal data.
              </p>
              <p>
                <strong className="bold">1.4.</strong> If you use the Service on
                behalf of a company, organization, or other legal entity, you
                represent and warrant that you are duly authorized to accept
                these Terms on its behalf, and references to “you” include that
                entity.
              </p>
              <p>
                <strong className="bold">1.5.</strong> The Service may be
                accessed from multiple jurisdictions, including the European
                Union and the United States, subject to applicable sanctions and
                export-control laws, to clause 3 below, and to these Terms. We
                make no representation that the Service is appropriate or
                available for use in any particular jurisdiction. Nothing in
                these Terms deprives a User of the protection afforded by
                mandatory provisions of the law of the country in which they
                reside.
              </p>
              <p>
                <strong className="bold">1.6.</strong> These Terms are drawn up
                in English. Where a translation is provided for convenience, the
                English version prevails in the event of a discrepancy, save
                where mandatory law provides otherwise.
              </p>
            </div>
          </section>
        </li>
        {/* 2 */}
        <li>
          <section>
            <h2>Definitions</h2>
            <div>
              <p>
                For the purposes of these Terms, the following terms shall
                apply:
              </p>
              <ul className="disc">
                <li>
                  <strong>Service (Website)</strong> – the AI-powered software
                  project estimation platform hosted at laestimator.ai,
                  including all its subdomains, pages, forms, tools, reports,
                  and related functionality.
                </li>
                <li>
                  <strong>User</strong> – any individual or legal entity that
                  accesses or uses the Service.
                </li>
                <li>
                  <strong>Consumer</strong> – a natural person who uses the
                  Service for purposes that are outside their trade, business,
                  craft, or profession.
                </li>
                <li>
                  <strong>Business User</strong> – any User that is not a
                  Consumer.
                </li>
                <li>
                  <strong>Estimation Flow</strong> – the sequence of questions,
                  selections, and input fields through which the User describes
                  a prospective software development project.
                </li>
                <li>
                  <strong>Estimate (Report)</strong> – the automatically
                  generated output of the Service, which may include an
                  indicative cost range, scope breakdown, timeline, and
                  suggested team composition.
                </li>
                <li>
                  <strong>User Content</strong> – any information, text, project
                  description, specification, document, image, or file that the
                  User enters into or uploads to the Service.
                </li>
                <li>
                  <strong>Privacy Policy</strong> – the privacy policy published
                  on the Website, describing how personal data is processed.
                </li>
              </ul>
            </div>
          </section>
        </li>
        {/* 3 */}
        <li>
          <section>
            <h2>Eligibility</h2>
            <div>
              <p>
                <strong className="bold">3.1.</strong>The Service is primarily
                intended for business and professional use, but it may also be
                used by Consumers, subject to these Terms. Where a provision of
                these Terms applies only to Consumers or only to Business Users,
                this is stated expressly.
              </p>
              <p>
                <strong className="bold">3.2.</strong> You may use the Service
                only if you are at least 18 (eighteen) years of age and have
                full legal capacity to enter into a binding agreement. The
                Service is not directed to, and We do not knowingly provide it
                to, individuals below this age.
              </p>
              <p>
                <strong className="bold">3.3.</strong> Notwithstanding clause
                3.2, if you are aged between 16 (sixteen) and 18 (eighteen), you
                may use the Service only with the consent and under the
                supervision of a parent or legal guardian, who accepts these
                Terms on your behalf and is responsible for your use of the
                Service.
              </p>
              <p>
                <strong className="bold">3.4.</strong> By using the Service, you
                represent and warrant that you meet the requirements of this
                clause 3 and that you are not prohibited from using the Service
                under any applicable law.
              </p>
              <p>
                <strong className="bold">3.5.</strong> You may not use the
                Service if you are located in, or are a resident of, a country
                or territory subject to comprehensive sanctions, or if you are
                listed on any applicable sanctions or restricted-party list.
              </p>
            </div>
          </section>
        </li>
        {/* 4 */}
        <li>
          <section>
            <h2>Description of the Service</h2>
            <div>
              <p>
                <strong className="bold">4.1.</strong> The Service is an
                automated tool that uses artificial intelligence, statistical
                models, and Lasoft’s historical project data to generate an
                indicative Estimate for a prospective custom software
                development project, based on the information the User provides
                in the Estimation Flow.
              </p>
              <p>
                <strong className="bold">4.2.</strong> The Service is provided
                free of charge. No fee, subscription, or payment is required to
                access the Service or to receive an Estimate.
              </p>
              <p>
                <strong className="bold">4.3.</strong> In order to receive the
                results of an estimation, the User is asked to complete a
                contact form and provide details such as name, business email
                address, and (optionally) company name, position, and phone
                number. Providing this information is voluntary; however, if it
                is not provided, We may be unable to deliver the Estimate to
                you. The processing of such data is governed by Our Privacy
                Policy.
              </p>
              <p>
                <strong className="bold">4.4.</strong> By submitting a request
                for an Estimate, you acknowledge that We may contact you in
                connection with that request in order to deliver the Estimate,
                clarify your inputs, or respond to your enquiry. Marketing
                communications are sent only where you have given separate
                consent, which may be withdrawn at any time.
              </p>
              <p>
                <strong className="bold">4.5.</strong> The Service is a
                marketing and pre-contractual tool of Lasoft. It does not create
                any obligation for Lasoft to provide software development or any
                other services to you.
              </p>
              <p>
                <strong className="bold">4.6.</strong> No service level,
                availability commitment, response time, or support obligation
                applies to the Service.
              </p>
            </div>
          </section>
        </li>
        {/* 5 */}
        <li>
          <section>
            <h2>Accuracy of Information Provided by the User</h2>
            <div>
              <p>
                <strong className="bold">5.1.</strong> You agree to provide
                information that is accurate, current, and complete, and to keep
                it up to date. The quality of an Estimate depends directly on
                the quality and completeness of the information you supply.
              </p>
              <p>
                <strong className="bold">5.2.</strong> You must not impersonate
                any person or entity, submit another person’s contact details
                without their authorization, or misrepresent your affiliation
                with any person or organization.
              </p>
              <p>
                <strong className="bold">5.3.</strong> Where the Service
                provides access credentials, a magic link, or any other means of
                accessing a saved Estimate, you are responsible for keeping them
                confidential and for all activity carried out through them. You
                must notify Us at{' '}
                <a
                  href="mailto:info@lasoft.org"
                  content="info@lasoft.org"
                  rel="nofollow"
                >
                  info@lasoft.org
                </a>{' '}
                without undue delay of any unauthorized use.
              </p>
            </div>
          </section>
        </li>
        {/* 6 */}
        <li>
          <section>
            <h2>User Content and File Uploads</h2>
            <div>
              <p>
                <strong className="bold">6.1.</strong> The Service allows you to
                enter project descriptions and to upload files such as
                specifications, requirement documents, briefs, diagrams,
                wireframes, and similar materials. All such materials constitute
                User Content.
              </p>
              <p>
                <strong className="bold">6.2.</strong> You retain all ownership
                rights, including intellectual property rights, in and to your
                User Content. Nothing in these Terms transfers ownership of your
                User Content to Lasoft.
              </p>
            </div>
            <h3>License Granted to Us</h3>
            <div>
              <p>
                <strong className="bold">6.3.</strong> By submitting User
                Content, you grant Lasoft a non-exclusive, worldwide,
                royalty-free, sublicensable (to Our hosting, infrastructure, and
                AI service providers only) license to store, host, reproduce,
                process, analyze, and display your User Content solely for the
                following purposes:
              </p>
              <ul className="disc">
                <li>
                  operating the Service and generating, delivering, and storing
                  your Estimate;
                </li>
                <li>
                  responding to your inquiry and providing any follow-up
                  consultation you request;
                </li>
                <li>
                  maintaining the security, integrity, and technical operation
                  of the Service;
                </li>
                <li>
                  improving the accuracy and quality of the Service, in
                  aggregated, anonymised, or de-identified form only.
                </li>
              </ul>
              <p>
                <strong className="bold">6.4.</strong> The licence in clause 6.3
                terminates when your User Content is deleted from Our systems,
                and in any event on termination of your use of the Service,
                except in respect of (i) aggregated, anonymized, or
                de-identified derivatives that no longer identify you or your
                project, in respect of which the licence is perpetual; and (ii)
                copies retained in routine backups or as required by applicable
                law, in respect of which the license subsists only for as long
                as, and to the extent that, those copies are retained. No other
                part of the license survives termination.
              </p>
              <p>
                <strong className="bold">6.5.</strong> We do not sell your User
                Content and do not disclose it to third parties for their own
                independent marketing purposes. We require Our AI and
                infrastructure service providers, by contract, not to use User
                Content to train or improve their own models.
              </p>
            </div>

            <h3>Your Warranties Regarding User Content</h3>
            <div>
              <p>By submitting User Content, you represent and warrant that:</p>
              <ul className="disc">
                <li>
                  you own the User Content or otherwise hold all rights,
                  licenses, and permissions necessary to submit it and to grant
                  the license in clause 6.3;
                </li>
                <li>
                  the User Content does not infringe any copyright, trademark,
                  patent, trade secret, database right, right of privacy, or
                  other right of any third party;
                </li>
                <li>
                  you are not subject to any confidentiality or non-disclosure
                  obligation that would be breached by submitting the User
                  Content to Us;
                </li>
                <li>
                  the User Content does not contain viruses, malware, or any
                  other harmful code and does not contain executable files
                  unless expressly permitted by the Service;
                </li>
                <li>
                  the User Content is not unlawful, defamatory, obscene,
                  discriminatory, harassing, or otherwise objectionable.
                </li>
              </ul>
            </div>

            <h3>Content You Must Not Upload</h3>
            <div>
              <p>You must not upload or enter into the Service:</p>

              <ul className="disc">
                <li>
                  special categories of personal data within the meaning of
                  Article 9 GDPR (including data revealing racial or ethnic
                  origin, political opinions, religious beliefs, trade union
                  membership, genetic or biometric data, health data, or data
                  concerning sex life or sexual orientation);
                </li>
                <li>
                  payment card numbers, bank account credentials,
                  government-issued identification numbers, or passwords;
                </li>
                <li>
                  personal data relating to third parties, unless you have a
                  lawful basis to disclose it to Us;
                </li>
                <li>
                  classified, export-controlled, or otherwise legally restricted
                  materials;
                </li>
                <li>
                  trade secrets or confidential information belonging to a third
                  party that you are not permitted to share.
                </li>
              </ul>
            </div>
            <h3>Confidentiality of Project Information</h3>
            <div>
              <p>
                <strong className="bold">6.6.</strong> We will treat non-public
                project information contained in your User Content with
                reasonable care and will not disclose it to third parties, other
                than to service providers acting on Our behalf under
                confidentiality obligations, or where disclosure is required by
                law.
              </p>
              <p>
                <strong className="bold">6.7.</strong> The Service is not a
                substitute for a non-disclosure agreement. If your project
                requires formal confidentiality protection before disclosure,
                please contact Us at{' '}
                <a
                  href="mailto:info@lasoft.org"
                  content="info@lasoft.org"
                  rel="nofollow"
                >
                  info@lasoft.org
                </a>{' '}
                to conclude an NDA before uploading materials.
              </p>
            </div>
            <h3>Storage, Removal, and Retention</h3>
            <div>
              <p>
                <strong className="bold">6.8.</strong> We may impose limits on
                file size, file format, and the number of uploads, and may
                change such limits at any time.
              </p>
              <p>
                <strong className="bold">6.9.</strong> We do not guarantee the
                storage, retention, backup, or availability of User Content or
                Estimates. You should retain your own copies of any materials
                you upload and of any Estimate you receive.
              </p>
              <p>
                <strong className="bold">6.10.</strong> We reserve the right to
                review, refuse, restrict, or remove any User Content that We
                reasonably believe violates these Terms or applicable law,
                without prior notice and without liability.
              </p>
            </div>
          </section>
        </li>
        {/* 7 */}
        <li>
          <section>
            <h2>Nature and Limitations of AI-Generated Estimates</h2>
            <div>
              <p>
                <strong>
                  This section is essential. Please read it carefully.
                </strong>
              </p>
              <p>
                <strong className="bold">7.1.</strong> Estimates are generated
                automatically by artificial intelligence models and statistical
                methods, without individual human review at the moment of
                generation. They are indicative and informational only.
              </p>
              <p>
                <strong className="bold">7.2.</strong> An Estimate does not
                constitute an offer, a quotation, a tender, a proposal, a price
                commitment, or any other legally binding statement by Lasoft and
                does not create a contract for the provision of software
                development or any other services. Any engagement of Lasoft
                requires a separately negotiated agreement signed by authorized
                representatives of both parties.
              </p>
              <p>
                <strong className="bold">7.3.</strong> An Estimate is derived
                solely from the limited information you provide and from
                generalized assumptions. Actual project cost, scope, duration,
                and staffing depend on many factors that the Service cannot
                assess, including but not limited to: final requirements and
                their stability, technical and architectural constraints,
                integrations with third-party systems, third-party licence and
                infrastructure costs, data migration, regulatory and compliance
                requirements, quality and availability of existing systems and
                documentation, market rates, currency fluctuations, and the
                timing of decisions on your side.
              </p>
              <p>
                <strong className="bold">7.4.</strong> Artificial intelligence
                systems may generate outputs that are inaccurate, incomplete,
                inconsistent, outdated, or unsupported by the underlying
                information. We make no representation or warranty that any
                Estimate is accurate, complete, reliable, current, or fit for
                any particular purpose. Actual figures may differ materially
                from those shown.
              </p>
              <p>
                <strong className="bold">7.5.</strong> An Estimate does not
                constitute professional advice of any kind, including financial,
                investment, accounting, budgetary, legal, tax, procurement, or
                engineering advice. You should obtain independent professional
                verification before relying on an Estimate.
              </p>
              <p>
                <strong className="bold">7.6.</strong> You are solely
                responsible for any decision you take on the basis of an
                Estimate, including budgeting, internal approvals, funding
                applications, procurement decisions, bids or tenders submitted
                to third parties, and contractual commitments to third parties.
                Lasoft accepts no responsibility for such decisions or their
                consequences.
              </p>
              <p>
                <strong className="bold">7.7.</strong> An Estimate reflects the
                models, data, and assumptions in effect at the moment it is
                generated. It has no validity period and is not updated
                automatically. We are under no obligation to update, re-issue,
                or correct any previously generated Estimate.
              </p>
              <p>
                <strong className="bold">7.8.</strong> You must not present an
                Estimate to any third party as an official quotation, offer,
                appraisal, certified valuation, or professional opinion issued
                by Lasoft, nor remove or alter any disclaimer, branding, or
                notice contained in it.
              </p>
              <p>
                <strong className="bold">7.9.</strong> We may change, retrain,
                or replace the underlying models and methodology at any time.
                Identical or similar inputs may therefore produce different
                Estimates at different times.
              </p>
            </div>
          </section>
        </li>
        {/* 8 */}
        <li>
          <section>
            <h2>License to Use the Service and the Estimate</h2>
            <div>
              <p>
                <strong className="bold">8.1.</strong> Subject to your
                compliance with these Terms, We grant you a limited,
                non-exclusive, non-transferable, non-sublicensable, revocable
                license to access and use the Service and to use the Estimate
                for your own internal business or personal evaluation purposes.
              </p>
              <p>
                <strong className="bold">8.2.</strong> You may download, print,
                and share the Estimate internally within your organization for
                the purposes set out in clause 8.1.
              </p>
              <p>
                <strong className="bold">8.3.</strong> You may not resell,
                license, distribute, publish, or otherwise commercially exploit
                the Estimate or the Service, nor present either as your own
                product or service.
              </p>
            </div>
          </section>
        </li>
        {/* 9 */}
        <li>
          <section>
            <h2>Prohibited Conduct</h2>
            <div>
              <p>When using the Service, you must not:</p>
              <ul className="disc">
                <li>
                  copy, modify, adapt, translate, reverse engineer, decompile,
                  or disassemble any part of the Service, or attempt to derive
                  its source code, model weights, prompts, pricing logic, or
                  underlying data, except to the extent such restriction is
                  prohibited by applicable law;
                </li>
                <li>
                  use robots, spiders, scrapers, crawlers, or any other
                  automated means to access the Service, extract data from it,
                  or submit inputs to it, other than lawful search engine
                  crawlers acting in accordance with Our robots.txt;
                </li>
                <li>
                  perform systematic or bulk querying intended to reconstruct,
                  replicate, or approximate Our estimation model, historical
                  project data, or pricing database (including model extraction,
                  model inversion, or benchmarking attacks);
                </li>
                <li>
                  use the Service, its outputs, or any data obtained from it to
                  develop, train, fine-tune, or evaluate any artificial
                  intelligence model, or to build a product or service that
                  competes with the Service or with Lasoft;
                </li>
                <li>
                  attempt to manipulate the Service through prompt injection,
                  adversarial inputs, jailbreaking, or any other technique
                  intended to cause the Service to operate outside its intended
                  function or to disclose non-public information;
                </li>
                <li>
                  circumvent, disable, or interfere with any security feature,
                  access control, authentication mechanism, rate limit, or usage
                  restriction;
                </li>
                <li>
                  introduce viruses, worms, trojans, logic bombs, or other
                  malicious code, or otherwise damage, disable, or impair the
                  Service;
                </li>
                <li>
                  impose an unreasonable or disproportionate load on the Service
                  or its infrastructure, or conduct any denial-of-service or
                  stress-testing activity;
                </li>
                <li>
                  gain or attempt to gain unauthorized access to the Service, to
                  other Users’ data, or to any server, system, or network
                  connected to the Service;
                </li>
                <li>
                  submit false, misleading, or fraudulent information, or use
                  the Service to deceive any third party;
                </li>
                <li>
                  use the Service for any unlawful purpose or in violation of
                  any applicable export control, sanctions, anti-corruption, or
                  data protection law;
                </li>
                <li>
                  use the Service in a manner that infringes the intellectual
                  property, privacy, or other rights of any person.
                </li>
              </ul>

              <p>
                <strong className="bold">9.1.</strong> Nothing in this section
                restricts good-faith security research conducted in accordance
                with the vulnerability disclosure procedure set out in clause
                10.1 of Our Privacy Policy and reported to{' '}
                <a
                  href="mailto:info@lasoft.org"
                  content="info@lasoft.org"
                  rel="nofollow"
                >
                  info@lasoft.org
                </a>
                .
              </p>
            </div>
          </section>
        </li>
        {/* 10 */}
        <li>
          <section>
            <h2>Intellectual Property Rights</h2>
            <div>
              <p>
                <strong className="bold">10.1.</strong> The Service and all of
                its components, including its software, source code, artificial
                intelligence models, algorithms, estimation methodology,
                databases, historical project data, design, user interface,
                layout, text, graphics, illustrations, icons, and the “Lasoft”
                and “LaEstimator” names, logos, and trademarks are owned by
                Lasoft or its licensors and are protected by copyright,
                trademark, database, trade secret, and other intellectual
                property laws.
              </p>
              <p>
                <strong className="bold">10.2.</strong> Except for the limited
                license expressly granted in clause 8, no right, title, or
                interest in or to the Service is transferred to you. All rights
                not expressly granted are reserved.
              </p>
              <p>
                <strong className="bold">10.3.</strong> You may not use Our
                trademarks, logos, or brand elements without Our prior written
                consent, except to identify the Service in a factual and
                non-misleading manner.
              </p>
              <p>
                <strong className="bold">10.4.</strong> If you voluntarily send
                Us suggestions, ideas, feature requests, or other feedback
                regarding the Service, you grant Us a perpetual, irrevocable,
                worldwide, royalty-free license to use, reproduce, modify, and
                exploit that feedback for any purpose, without any obligation of
                confidentiality, attribution, or compensation to you.
              </p>
              <p>
                <strong className="bold">10.5.</strong> If you believe that
                content available through the Service infringes your
                intellectual property rights, please notify Us at{' '}
                <a
                  href="mailto:info@lasoft.org"
                  content="info@lasoft.org"
                  rel="nofollow"
                >
                  info@lasoft.org
                </a>
                , providing: identification of the protected work; the location
                of the allegedly infringing material; your contact details; a
                statement that you have a good-faith belief that the use is not
                authorized; and a statement that the information in your notice
                is accurate. We will review every properly substantiated notice
                and take appropriate action, which may include removing the
                material and suspending the responsible User.
              </p>
            </div>
          </section>
        </li>
        {/* 11 */}
        <li>
          <section>
            <h2>Third-Party Services and Links</h2>
            <div>
              <p>
                <strong className="bold">11.1.</strong> The Service relies on
                third-party providers for hosting, analytics, customer
                relationship management, communications, and artificial
                intelligence processing. We identify these providers, where
                relevant, in Our Privacy Policy, and they operate under their
                own terms and privacy policies.
              </p>
              <p>
                <strong className="bold">11.2.</strong> The Service may contain
                links to third-party websites or resources. We provide such
                links for convenience only. We do not control, endorse, or
                assume responsibility for the content, products, services, or
                practices of any third party, and you access third-party
                resources at your own risk.
              </p>
            </div>
          </section>
        </li>
        {/* 12 */}
        <li>
          <section>
            <h2>Availability, Modification, and Interruption of the Service</h2>
            <div>
              <p>
                <strong className="bold">12.1.</strong> We will make reasonable
                efforts to keep the Service available, but We do not warrant
                that access will be uninterrupted, timely, secure, or free of
                errors or defects.
              </p>
              <p>
                <strong className="bold">12.2.</strong> We may at any time and
                without prior notice modify, update, suspend, restrict, or
                discontinue the Service or any part of it, including any
                feature, model, or output format. Where reasonably practicable,
                We will give advance notice of a permanent discontinuation.
              </p>
              <p>
                <strong className="bold">12.3.</strong> The Service may be
                temporarily unavailable due to maintenance, upgrades, technical
                failures, or circumstances beyond Our control. Because the
                Service is provided free of charge, We accept no liability for
                such unavailability.
              </p>
            </div>
          </section>
        </li>
        {/* 13 */}
        <li>
          <section>
            <h2>Suspension and Termination</h2>
            <div>
              <p>
                <strong className="bold">13.1.</strong> We may suspend or
                terminate your access to the Service with immediate effect if
                you breach these Terms, if We reasonably suspect unlawful or
                fraudulent use, or if your use poses a risk to the security,
                integrity, or availability of the Service or to other Users.
              </p>
              <p>
                <strong className="bold">13.2.</strong> You may stop using the
                Service at any time. You may request deletion of the data
                associated with your use by contacting Us at{' '}
                <a
                  href="mailto:info@lasoft.org"
                  content="info@lasoft.org"
                  rel="nofollow"
                >
                  info@lasoft.org
                </a>
                , in accordance with Our Privacy Policy.
              </p>
              <p>
                <strong className="bold">13.3.</strong> Termination does not
                affect any rights or obligations accrued before termination.
              </p>
              <p>
                <strong className="bold">13.4.</strong> The following provisions
                survive termination: clauses 6.4 to 6.7 (license run-off,
                warranties, and confidentiality), 7 (nature and limitations of
                Estimates), 8.3, 9, 10, 14, 15, 16, 17, 20, and 21. The license
                granted in clause 6.3 survives only to the limited extent set
                out in clause 6.4, and this clause 13.4 does not extend it.
              </p>
            </div>
          </section>
        </li>
        {/* 14 */}
        <li>
          <section>
            <h2>Disclaimer of Warranties</h2>
            <div>
              <p>
                <strong className="bold">14.1.</strong> To the maximum extent
                permitted by applicable law, the Service and all Estimates are
                provided “as is” and “as available," with all faults and without
                warranty of any kind.
              </p>
              <p>
                <strong className="bold">14.2.</strong> We expressly disclaim
                all warranties, whether express, implied, statutory, or
                otherwise, including any implied warranties of merchantability,
                satisfactory quality, fitness for a particular purpose,
                accuracy, completeness, title, non-infringement, and any
                warranties arising from course of dealing or usage of trade.
              </p>
              <p>
                <strong className="bold">14.3.</strong> We do not warrant that
                the Service will meet your requirements, that any Estimate will
                be accurate or reliable, that defects will be corrected, or that
                the Service is free of harmful components.
              </p>
              <p>
                <strong className="bold">14.4.</strong> Nothing in this section
                excludes or limits any warranty or right that cannot be excluded
                or limited under applicable mandatory law. The statutory rights
                of Consumers are not affected.
              </p>
            </div>
          </section>
        </li>
        {/* 15 */}
        <li>
          <section>
            <h2>Limitation of Liability</h2>
            <div>
              <p>
                <strong className="bold">15.1.</strong> To the maximum extent
                permitted by applicable law, Lasoft, its affiliates, directors,
                employees, and contractors shall not be liable for any indirect,
                incidental, special, consequential, exemplary, or punitive
                damages, nor for any loss of profit, revenue, business,
                contracts, anticipated savings, goodwill, reputation,
                opportunity, or data, nor for the cost of procuring substitute
                services, arising out of or in connection with the Service, any
                Estimate, or any reliance placed on an Estimate, regardless of
                the legal basis of the claim and even if We have been advised of
                the possibility of such damages.
              </p>
              <p>
                <strong className="bold">15.2.</strong> Because the Service is
                provided free of charge, Our total aggregate liability arising
                out of or in connection with the Service, whether in contract,
                tort (including negligence), or otherwise, is limited to EUR 100
                (one hundred euros) in the aggregate for all claims.
              </p>
              <p>
                <strong className="bold">15.3.</strong> Nothing in these Terms
                excludes or limits Our liability for death or personal injury
                caused by Our negligence; fraud or fraudulent misrepresentation;
                intentional misconduct or gross negligence; or any other
                liability that cannot lawfully be excluded or limited.
              </p>
              <p>
                <strong className="bold">15.4.</strong> Where you are a
                Consumer, the exclusions and limitations in this section apply
                only to the extent permitted by the mandatory consumer
                protection law applicable in your country of residence. Your
                statutory rights remain unaffected.
              </p>
              <p>
                <strong className="bold">15.5.</strong> You acknowledge that the
                allocation of risk in these Terms reflects the fact that the
                Service is made available to you without charge and that
                Estimates are indicative only.
              </p>
            </div>
          </section>
        </li>
        {/* 16 */}
        <li>
          <section>
            <h2>Indemnification</h2>
            <div>
              <p>
                <strong className="bold">16.1.</strong> If you are a Business
                User, you agree to indemnify, defend, and hold harmless Lasoft,
                its affiliates, and their respective directors, employees, and
                contractors from and against any claim, demand, proceeding,
                loss, liability, damage, cost, or expense (including reasonable
                legal fees) arising out of or in connection with: (i) your User
                Content; (ii) your breach of these Terms or of any applicable
                law; (iii) your infringement of any third-party right; or (iv)
                any decision taken by you or by a third party in reliance on an
                Estimate.
              </p>
              <p>
                <strong className="bold">16.2.</strong> This section does not
                apply to Consumers except to the extent permitted by applicable
                mandatory law, and does not limit the statutory rights of
                Consumers.
              </p>
            </div>
          </section>
        </li>
        {/* 17 */}
        <li>
          <section>
            <h2>Privacy and Data Protection</h2>
            <div>
              <p>
                <strong className="bold">17.1.</strong> Personal data submitted
                through the Service is processed in accordance with Our Privacy
                Policy and with the General Data Protection Regulation (EU)
                2016/679 and other applicable data protection legislation.
                Please review the Privacy Policy before using the Service.
              </p>
              <p>
                <strong className="bold">17.2.</strong> Where your User Content
                contains personal data relating to third parties, you represent
                and warrant that you, or the organization on whose behalf you
                act, have a valid legal basis for disclosing that data to Us and
                have provided any notice and obtained any consent required under
                applicable data protection law.
              </p>
              <p>
                <strong className="bold">17.3.</strong> To the extent that We
                process personal data contained in your User Content on your
                behalf and on your documented instructions, We act as a
                processor within the meaning of Article 4(8) GDPR, and Our Data
                Processing Agreement applies to that processing. The Data
                Processing Agreement forms an integral part of these Terms and
                is incorporated by reference; it is published on the Website,
                and a copy may be obtained at any time by writing to{' '}
                <a
                  href="mailto:info@lasoft.org"
                  content="info@lasoft.org"
                  rel="nofollow"
                >
                  info@lasoft.org
                </a>
                . It sets out, in accordance with Article 28(3) GDPR, the
                subject matter and duration of the processing, its nature and
                purpose, the categories of data and data subjects, the security
                measures applied, the conditions for engaging sub-processors,
                the assistance We provide in relation to data subject rights and
                personal data breaches and the arrangements for deletion or
                return of the data. No separate request or negotiation is
                required for it to apply.
              </p>
              <p>
                <strong className="bold">17.4.</strong> The Service uses cookies
                and similar technologies as described in Our Privacy Policy. You
                may manage your preferences through the cookie consent banner or
                your browser settings.
              </p>
            </div>
          </section>
        </li>
        {/* 18 */}
        <li>
          <section>
            <h2>Provisions for Consumers</h2>
            <div>
              <p>
                <strong className="bold">18.1.</strong> The Service is supplied
                without payment of a price. Accordingly, no payment obligation,
                subscription, or automatic renewal arises from your use of the
                Service, and no refund can become due.
              </p>
              <p>
                <strong className="bold">18.2.</strong> Where, under applicable
                consumer law, a right of withdrawal applies to a contract
                concluded at a distance through the Service, a Consumer may
                withdraw from it within 14 (fourteen) days without giving any
                reason by sending an unequivocal statement to{' '}
                <a
                  href="mailto:info@lasoft.org"
                  content="info@lasoft.org"
                  rel="nofollow"
                >
                  info@lasoft.org
                </a>
                .
              </p>
              <p>
                <strong className="bold">18.3.</strong> Complaints regarding the
                Service may be submitted at any time to{' '}
                <a
                  href="mailto:info@lasoft.org"
                  content="info@lasoft.org"
                  rel="nofollow"
                >
                  info@lasoft.org
                </a>
                . We will acknowledge and respond to a Consumer complaint
                without undue delay and in any event within 14 (fourteen) days
                of receipt.
              </p>
              <p>
                <strong className="bold">18.4.</strong> Consumers resident in
                Poland may also seek free assistance from a municipal or
                district consumer ombudsman (miejski lub powiatowy rzecznik
                konsumentów), a social organization whose statutory tasks
                include consumer protection, a regional inspectorate of the
                Trade Inspection (Wojewódzki Inspektorat Inspekcji Handlowej),
                or the Office of Competition and Consumer Protection (UOKiK).
                Consumers resident elsewhere in the European Union may contact
                their national European Consumer Centre (ECC-Net). Please note
                that the European Commission’s online dispute resolution (ODR)
                platform ceased operating on 20 July 2025 and is no longer
                available.
              </p>
              <p>
                <strong className="bold">18.5.</strong> Participation in any
                out-of-court dispute resolution procedure is voluntary for both
                parties. We are not obliged to participate and are not bound by
                any consumer arbitration board, unless required by law.
              </p>
              <p>
                <strong className="bold">18.6.</strong> Nothing in these Terms
                deprives a Consumer of the protection afforded by the mandatory
                provisions of the law of the country in which the Consumer
                habitually resides.
              </p>
            </div>
          </section>
        </li>
        {/* 19 */}
        <li>
          <section>
            <h2>Changes to These Terms</h2>
            <div>
              <p>
                <strong className="bold">19.1.</strong> We reserve the right to
                amend or update these Terms at any time, for example to reflect
                changes to the Service, to Our business, or to applicable law.
              </p>
              <p>
                <strong className="bold">19.2.</strong> The revised Terms will
                be published on this page with an updated “Last updated” date.
                Where changes are material, We will make reasonable efforts to
                notify Users in advance, for example, by a notice on the Website
                or by email.
              </p>
              <p>
                <strong className="bold">19.3.</strong> Where a change is
                material, and you are a Consumer, We will notify you of the
                change at least 14 (fourteen) days before it takes effect by a
                prominent notice on the Website or, where We hold your email
                address, by email. The notice will describe the change and the
                date on which it takes effect and will inform you of your right
                to reject it by ceasing to use the Service before that date.
              </p>
              <p>
                <strong className="bold">19.4.</strong> Your continued use of
                the Service after the revised Terms take effect constitutes
                acceptance of them. If you do not accept the revised Terms, you
                must stop using the Service; no charge or penalty will apply.
              </p>
              <p>
                <strong className="bold">19.5.</strong> Amendments apply only
                prospectively. No amendment will retroactively reduce or
                extinguish any right that has already accrued to you, or any
                claim that has already arisen, before the amendment takes
                effect. Your use of the Service before an amendment takes effect
                continues to be governed by the version of these Terms in force
                at that time.
              </p>
              <p>
                <strong className="bold">19.6.</strong> Amendments required by
                mandatory law or by an order of a competent authority or court
                may take effect on the date required by that law or order.
              </p>
            </div>
          </section>
        </li>
        {/* 20 */}
        <li>
          <section>
            <h2>Governing Law and Dispute Resolution</h2>
            <div>
              <p>
                <strong className="bold">20.1.</strong> These Terms and any
                non-contractual obligations arising out of or in connection with
                them are governed by the laws of the Republic of Poland,
                excluding its conflict-of-law rules and excluding the United
                Nations Convention on Contracts for the International Sale of
                Goods.
              </p>
              <p>
                <strong className="bold">20.2.</strong> The parties will attempt
                in good faith to resolve any dispute amicably. Please contact Us
                first at{' '}
                <a
                  href="mailto:info@lasoft.org"
                  content="info@lasoft.org"
                  rel="nofollow"
                >
                  info@lasoft.org
                </a>
                , describing the issue and the outcome you seek.
              </p>
              <p>
                <strong className="bold">20.3.</strong> Any dispute between
                Lasoft and a Business User that cannot be resolved amicably
                shall be submitted to the exclusive jurisdiction of the Polish
                courts having jurisdiction over the registered seat of LaEurope
                Sp. z o.o. in Łódź, Poland.
              </p>
              <p>
                <strong className="bold">20.4.</strong> Clauses 20.1 and 20.3 do
                not deprive a Consumer of the protection of the mandatory
                provisions of the law of their country of habitual residence,
                nor of the right to bring or defend proceedings before the
                courts of that country.
              </p>
            </div>
          </section>
        </li>
        {/* 21 */}
        <li>
          <section>
            <h2>Miscellaneous</h2>
            <div>
              <p>
                <strong className="bold">21.1.</strong> Severability. If any
                provision of these Terms is held invalid, illegal, or
                unenforceable, that provision shall be modified to the minimum
                extent necessary to make it enforceable, and the remaining
                provisions shall continue in full force and effect.
              </p>
              <p>
                <strong className="bold">21.2.</strong> No waiver. Our failure
                or delay in enforcing any provision of these Terms does not
                constitute a waiver of that provision or of any other right.
              </p>
              <p>
                <strong className="bold">21.3.</strong> Entire agreement. These
                Terms, together with the Privacy Policy, constitute the entire
                agreement between you and Lasoft regarding the Service and
                supersede all prior understandings relating to its subject
                matter.
              </p>
              <p>
                <strong className="bold">21.4.</strong> Assignment. We may
                assign or transfer these Terms, in whole or in part, to an
                affiliate or in connection with a merger, acquisition, or
                transfer of assets. You may not assign or transfer your rights
                or obligations without Our prior written consent.
              </p>
              <p>
                <strong className="bold">21.5.</strong> Force majeure. We are
                not liable for any failure or delay in performance caused by
                events beyond Our reasonable control, including acts of war or
                armed conflict, terrorism, natural disasters, epidemics, power
                or internet outages, failures of third-party providers, strikes,
                or acts of public authorities.
              </p>
              <p>
                <strong className="bold">21.6.</strong> No partnership. Nothing
                in these Terms creates a partnership, joint venture, agency,
                employment, or fiduciary relationship between you and Lasoft.
              </p>
              <p>
                <strong className="bold">21.7.</strong> Notices. We may send
                notices to you at the email address you provide. You may send
                notices to Us at{' '}
                <a
                  href="mailto:info@lasoft.org"
                  content="info@lasoft.org"
                  rel="nofollow"
                >
                  info@lasoft.org
                </a>
                .
              </p>
              <p>
                <strong className="bold">21.8.</strong> Headings. Headings are
                for convenience only and do not affect the interpretation of
                these Terms.
              </p>
            </div>
          </section>
        </li>

        {/* 22 */}
        <li>
          <section>
            <h2>Contact Us</h2>
            <div>
              <p>
                If you have any questions about these Terms or the Service,
                please contact Us:
              </p>
              <dl>
                <div>
                  <dt>LaSoft | </dt>
                  <dd>
                    <Link to="/">laestimator.ai</Link>
                  </dd>
                </div>
                <div className="simple-row">
                  <dt>Operating entity: </dt>
                  <dd> LaEurope Sp. z o.o., REGON: 368844046</dd>
                </div>
                <div className="simple-row">
                  <dt>Registered address: </dt>
                  <dd>
                    ul. Piotrkowska, 148/150, miejsc. ŁÓDŹ, kod 90-063, POLSKA,
                  </dd>
                </div>
                <div>
                  <dt>NIP: </dt>
                  <dd>8971848582, REGON: 368844046</dd>
                </div>
                <div>
                  <dt>Email: </dt>
                  <dd>
                    <a
                      href="mailto:info@lasoft.org"
                      content="info@lasoft.org"
                      rel="nofollow"
                    >
                      info@lasoft.org
                    </a>
                  </dd>
                </div>
                <div>
                  <dt>Phone (US): </dt>
                  <dd>+1 206 681 1521</dd>
                </div>
                <div>
                  <dt>Phone (Poland): </dt>
                  <dd>+48 422 202 701</dd>
                </div>
                <div>
                  <dt>Phone (Ukraine): </dt>
                  <dd>+38 091 481 07 01</dd>
                </div>
              </dl>
              <p>© 2026 LaSoft. All rights reserved. | laestimator.ai</p>
            </div>
          </section>
        </li>
      </ul>
    </div>
  </main>
);

export default TermsOfUse;
